/*  Replace span with strong in fn_getModal_confirm Jun 3, 2023 */
/* Amend fn_fmtDt  Oct 10th, 2023  Reverted Oct 21 2023*/
/* Add T00:00:00 to fn_fmtDt  Add T00:00:00 Oct 28th, 2023*/
/* Amend fn_hrefLink  Nov 18, 2023 */
/* Add fn_timeFmt  Dec 2, 2023 */
/* Amend fn_timeFmt  Jan 21, 2024 */
/* Add fn_lkpRefNameId,fn_getMoal_upload,  Febuary 28, 2024 */
/* Add fn_lkpRefNameId,fn_getMoal_upload,  Febuary 28, 2024 */
/* Add  fn_userEnabledPages,fn_checkPageEnabled Apr 20, 2024 */
/* Add tableReadOnlyColumns, tableRequiredColumns for read only columns Feb 1, 2025*/
/* Add kbdpAlertInfo Mar 21, 2025 */
/* Bug fix for required Fields  Apr 5, 2025 */
/* Add function enableColumnsResizable May 20, 2025 */
/* Add Revenue Forecasting Aug 8, 2026 */
/* Add Meetings Oct 17, 2026 */
/* Add getTimeZone for Reminders Oct 3 , 2026 */
import {fn_appEnt, userSettings, api_baseURL} from "@/utils/ref-data.js";
import {kbdpAlert, kbdpRecord} from "@/views/KBDP.vue";
import {fn_getAppTenantSettings,fn_getAppUserSettings, fn_saveAppUserSetting} from "@/utils/api.js";

//For Individual Imports
export {
   kbdpAlert,
   kbdpRecord,
   fn_humanizeLabel,
   fn_getHashBase,
   fn_getHashId,
   fn_lkpRefIdNameMulti,
   fn_lkpRefIdName,

   fn_spliceById,
   // fn_dateDiff,
   fn_calcSum,
   fn_calcPct,
   fn_isoDtStr,
   // fn_fmtDtm,
   fn_fmtDtmStr,
   fn_fmtDt,
   fn_fmtMoney,
   fn_fmtSf,
   fn_fmtFileSize,
   fn_getModal_confirm,
   fn_getMoal_createNew,
   fn_getMoal_upload,
   fn_getModal_addGoal,

   fn_footerFmtr_value,
   fn_hrefVwRec,
   fn_taskParentLkp,
   fn_recLbl,
   // fn_lclTableSorter,
   fn_taskCol_ActivityScope,
   fn_resizeHelper,
   fn_resizeColHelper,
   fn_tmNameShort,
   fn_profilePicURL,

   fn_getUserOpts,
   fn_saveUserOpts,
   fn_hrefLink,
   fn_timeFmt,
   fn_lkpRefNameId,
   fn_userEnabledPages,
   fn_checkPageEnabled,
   fn_checkValidRoute,
   fn_userAvailablePages,
   kbdpAlertInfo,
   enableResizableTable,
   enableResizableColumn,
   getTimeZone,
};
export default {
   fn_humanizeLabel,
   fn_spliceById,
   fn_dateDiff,
   fn_calcSum,
   fn_calcPct,
   fn_isoDtStr,
   fn_fmtDtm,
   fn_fmtDtmStr,
   fn_fmtDt,
   fn_fmtMoney,
   fn_fmtSf,
   fn_fmtFileSize,

   fn_getModal_confirm,
   fn_hrefVwRec,

   fn_recLbl,

   fn_wss_uc,
   fn_getUserOpts,
   fn_saveUserOpts,
   fn_hrefLink,
   fn_timeFmt,
};

function fn_humanizeLabel(name) {
   return (
      name
         .replace(/([A-Z])/g, " $1") //camelCase --> camel Case
         .replace(/^./, (x) => x.toUpperCase()) //camel Case --> Camel Case
         .replace(" Id", "")
         // .replace(/Id$/, function(x) {return isPK ? x : "";})
         // .replace("-", "")
         .replace(/No$/, "#")
         .replace(/Nm$/, "Name")
         .replace(/Desc$/, "Description")
         .replace(/U T C$/, "UTC")
   );
}

function fn_getHashBase(vc) {
   let h = vc.$route.hash;
   let s = h.indexOf('/');
   return s > 0 ? h.substring(1, s) : h.substring(1);

}
function fn_getHashId(vc) {
   let h = vc.$route.hash;
   let s = h.indexOf('/');
   return s > 0 ? h.substring(s + 1).trim() : null;
}

function fn_lkpRefIdNameMulti(col, idVals) {
   let len = (idVals || []).length;
   if (!len) return null;
   let frst = fn_lkpRefIdName(col._refData, col, idVals[0][col._refId]);
   len--;
   return frst + (len > 0 ? ` (+${len} More)` : '');
}

function fn_lkpRefIdName(_refData, col, idVal) {
	
	
   if (!(_refData || []).length) return idVal;

   let idKey = _refData[0].id ? 'id' : (col._refId || col.field || col.key || '');
   let nameKey = _refData[0].name ? 'name' : (col._refName || (idKey.slice(0, -2) + 'Name'));
   let lkp = _refData.filter(x => x[idKey] == idVal)[0];
	
   if (lkp) {
      return lkp[nameKey];
   }
   else {
      return idVal;
   }
}



function fn_spliceById(array, idKey, idVal, newVal) {
   if (!array) return;
   let ix = array.map(x => x[idKey]).indexOf(idVal);

   if (newVal !== undefined) {
      if (ix > -1) array.splice(ix, 1, newVal);
      else array.push(newVal);
   }
   else if (ix > -1) {
      array.splice(ix, 1);
   }
}

function fn_dateDiff(dt1, dt2, abs) {
   if (!dt1) return 'error';
   if (!dt2) dt2 = new Date().toLocaleDateString(); //Today

   if (dt1.indexOf('-') == -1) dt1 = fn_isoDtStr(dt1);
   if (dt2.indexOf('-') == -1) dt2 = fn_isoDtStr(dt2);

   dt1 = new Date(dt1 + ':00:00');
   dt2 = new Date(dt2 + ':00:00');
   let diff = (dt1 - dt2) / 1000 / 60 / 60 / 24;

   if (abs) return Math.abs(diff);
   else return diff;

}
function fn_calcSum(data, roundToInt) {
   let sum = data.reduce((sum, i) => {return sum + (i || 0);}, 0);
   if (roundToInt) return Math.round(sum);
   else return sum;
}
function fn_calcPct(data, val) {
   let s = data.reduce((sum, i) => {return sum + (i || 0);}, 0);
   return (Math.round(val * 100 / s) / 1.0) + '%';
}
function fn_isoDtStr(dt) {
   if (dt) {
      if (isNaN(dt)) dt = Date.parse(dt);
      if (isNaN(dt)) return 'Invalid Date';
      return new Date(dt).toISOString().substring(0, 10);
   }
   else {
      //Today
      return fn_isoDtStr(new Date().toLocaleDateString());
      // return new Date().toISOString().substring(0, 10);
   }
}
function fn_fmtDtm(dtm) {
   return dtm ? new Date(dtm).toLocaleString() : '';
}
function fn_fmtDtmStr(dtmStr, lcl) {
   if (!dtmStr) return '';

   if (lcl && !dtmStr.endsWith('Z')) dtmStr += 'Z';
   return new Date(dtmStr).toLocaleString();
}
function fn_fmtDt(dt) {
   return dt ? new Date(dt + 'T00:00:00').toLocaleDateString() : '';
   //return dt ? new Date(dt).toLocaleDateString() : '';
}
function fn_fmtMoney(val, kmb) {
   return (val || val === 0 || !isNaN(val)) ? '$' + (kmb ? fn_fmtKMB(val) : Math.round(val).toLocaleString('en')) : '';
}
function fn_fmtKMB(num) {
   if (num >= 1e9) return (num / 1e9).toFixed(2).replace(/\.0$/, '') + 'B';
   if (num >= 1e6) return (num / 1e6).toFixed(2).replace(/\.0$/, '') + 'M';
   if (num >= 1000) return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
   return num;
}

function fn_fmtSf(val) {
   return val ? Math.round(val).toLocaleString('en') + ' sf' : '';
}
function fn_fmtFileSize(bytes) {
   if (bytes == 0) return '0 Bytes';
   var k = 1000,
      dm = 1,
      sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
      i = Math.floor(Math.log(bytes) / Math.log(k));
   return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

function fn_getMoal_createNew(vc) {
   let ce = vc.$createElement;
   let title = ce('div',
      [
         ce('fa-icon',
            {
               attrs: {icon: 'folder-plus', },
               class: {"mr-2": true, }
            }
         ),
         ce('span', 'Create New')
      ]
   );

   let msgVNode = ce('b-form-group',
      {
         attrs: {label: 'Select from the options below', 'label-for': 'bm-create-new-opt', },
      },
      [
         ce('b-form-select',
            {
               attrs: {
                  id: 'bm-create-new-opt',
                  options: vc.c_crtNwOpts,
                  size: "sm",
                  plain: true,
               },
               on: {
                  change: (e) => {vc.d_crtNwKey = e;}
               },
               props: {
                  value: vc.d_crtNwKey
               },
            }
         )
      ]
   );

   let opt = fn_getCommonMsgBoxOpts();
   opt.title = title;
   return {msgVNode, opt};

}

function fn_getModal_addGoal(vc, MoQtr, yrOpts, yrData) {
   let ce = vc.$createElement;
   let title = ce('div',
      [
         ce('fa-icon',
            {
               attrs: {icon: 'folder-plus', },
               class: {"mr-2": true, }
            }
         ),
         ce('span', `Add ${MoQtr.keyLbl} Goals`)
      ]
   );

   let msgVNode = ce('div',
      {
         attrs: {id: 'bm-create-goal-yr'}
      },
      [
         ce('b-form-select',
            {
               attrs: {
                  options: yrOpts,
                  size: "sm",
               },
               on: {
                  change: (e) => {yrData.yr = e;}
               },
               props: {
                  value: yrData.yr
               }
            }
         ),
         ce('p', `Select the year for which you want to add ${MoQtr.key} goals`),
      ]
   );


   let opt = fn_getCommonMsgBoxOpts();
   opt.title = title;
   opt.okDisabled = true;
   return {msgVNode, opt};

}

function fn_getModal_confirm(vc, content) {

   let ce = vc.$createElement;
   let title = ce('div',
      [
         ce('fa-icon',
            {
               attrs: {icon: content.titleIcon || 'exclamation-triangle', },
               class: {"text-warning": true, "mr-2": true, }
            }
         ),
         ce('strong', content.titleText)
      ]
   );

   let msgVNodes = [
      ce('div',
         {
            class: {"small": true, }
         },
         content.message1
      ),
      ce('div',
         {
            class: {"pt-2 small": true, }
         },
         content.message2
      ),
   ];



   let opt = fn_getCommonMsgBoxOpts();
   opt.title = title;
   opt.okTitle = 'Yes';
   opt.cancelTitle = 'No';
   return {msgVNodes, opt};
}


function fn_getCommonMsgBoxOpts() {
   return {
      size: 'sm',
      buttonSize: 'sm',
      // modalClass: 'mt-5',
      centered: true,
      headerClass: 'py-0 pt-2 border-0',
      titleTag: 'div',
      bodyClass: 'py-2',
      footerClass: 'py-0 pb-2 border-0 flex-row-reverse',
      cancelVariant: 'outline-secondary',
      noCloseOnBackdrop: true,
      noFade: true,
      hideHeaderClose: true,
   };
}

function fn_footerFmtr_value(data, value) {
   let field = this.field;
   let d = data.map(r => r[field]);
   let cvSum = fn_calcSum(d, true);
   let ttlSum = value;

   let ttl = $('<span>', {}).append(`Total Value: <b>${fn_fmtMoney(ttlSum)}</b>`)[0].outerHTML;
   let showCv = cvSum != ttlSum;
   if (showCv) {
      let cv = $('<small>', {class: 'ml-2 text-black-50', title: 'Total based on '})
         .append('Current Page/View: ' + fn_fmtMoney(cvSum))[0].outerHTML;
      return [ttl, cv].join('');
   }
   else {
      return ttl;
   }
}


function fn_taskParentLkp(val, refData, prntAppEnt) {

   let idKey = prntAppEnt.idKey;
   let numKey = prntAppEnt.numKey;
   let nameKey = prntAppEnt.nameKey;

   let rdLkp = refData[idKey] || [];
   let lkp = rdLkp.filter(x => x[idKey] == val)[0] || {};

   return {
      prntNo: lkp[numKey],
      prntName: lkp[nameKey]
   };
}



function fn_tmNameShort(tmNm) {
   let a = tmNm.split(' ');
   let a1 = a[1];
   return a[0] + (a1 ? ' ' + a1[0] + '.' : '');
}

function fn_hrefLink(type, value) {

	if(type=='email') return `mailto:${value}`;
	if(type=='tel') return `tel:${value}`;
	if(type=='url') return value;
}
function fn_hrefVwRec(appEntKey, recNo) {
   return `#${appEntKey}-view/${recNo}`; //Must start with hash #
}

function fn_recLbl(recNo, recNm) {
   let srn = userSettings.userOptions.showRecordNumbers;
   return (srn ? recNo + ' - ' : '') + recNm;
}


function fn_taskCol_ActivityScope() {
   return {
      field: "prntId",
      title: "Activity Scope",
      default: true,
      linkFn: (col, row, vc) => {
         let pt = row['prntType'];
         if (pt == 'cal') return null;
         else if (!vc) return 1;

         let prntAE = fn_appEnt(pt);
         let val = row[col.field];
         let lkp = fn_taskParentLkp(val, vc.d_refData, prntAE);
         return {
            path: fn_hrefVwRec(prntAE.key, lkp.prntNo),
            appEntKey: prntAE.key,
            recNo: lkp.prntNo,
         };
      },
      valFmtFn: (val, col, row, vc) => {
         let pt = row['prntType'];
         let prntAE = fn_appEnt(pt);

         if (pt == 'cal') return prntAE.Name + ' Activity';
         let lkp = fn_taskParentLkp(val, vc.d_refData, prntAE);
         return fn_recLbl(lkp.prntNo, lkp.prntName);
      }

   };
}


async function fn_resizeHelper($resizer, $tgtElem, width, height) {
   $resizer.addClass('resizing');
   let resW = $resizer[0].offsetWidth;
   let resH = $resizer[0].offsetHeight;

   $resizer.on('mousemove', (e) => {
      // e.preventDefault();
      if (width) {
         let offsetBy = e.offsetX - (resW / 2);
         if (Math.abs(offsetBy) > 10) {
            let oldW = $tgtElem[0].offsetWidth;
            let newW = (Math.round((oldW + offsetBy) / 10) * 10);
            if (newW < (width.min || 20)) return;
            if (width.max && newW >= width.max && offsetBy > 0) return;
            newW += 'px';
            $tgtElem.css('width', newW);
            width.newW = newW;
         }
      }
      if (height) {
         let offsetBy = (resH / 2) - e.offsetY;
         if (Math.abs(offsetBy) > 10) {
            let oldH = $tgtElem[0].offsetHeight;

            let newH = height.inv ? oldH + offsetBy : oldH - offsetBy;//Inverse (drag up vs drag down)
            newH = (Math.round(newH / 10) * 10);
            if (newH < (height.min || 20)) return;
            if (height.max && newH >= height.max && offsetBy > 0) return;
            newH += 'px';
            $tgtElem.css('height', newH);
            height.newH = newH;
         }
      }
   });

   return new Promise((res, rej) => {
      $(window).one('mouseup', (e) => {
         $resizer.off('mousemove');
         $resizer.removeClass('resizing');
         res();
      });
   });
}

async function fn_resizeColHelper(e, col, d_opts, tblId) {
   let $resizer = $(e.target);
   let $th = $resizer.closest('th');
   // let isLast = $th.next().next().length == 0;
   let $thEnd = $th.siblings().last();
   let $tbl = $resizer.closest('table');

   let pageX = e.pageX;
   let thW = Math.ceil($th[0].offsetWidth / 5) * 5;

   let tblW = Math.ceil($tbl[0].offsetWidth / 5) * 5;

   let thWNew;
   // let tblWNew;
   // let thEndW = $thEnd[0].offsetWidth;

   col.resizing = true;
   $(document).on('mousemove', (e) => {
      let diffX = e.pageX - pageX;
      if (Math.abs(diffX) % 5 != 0) return;  //Only do multiples of 5

      thWNew = thW + diffX;
      if (thWNew < 60) {
         thWNew = 60;
         diffX = 60 - thW;
      }
      col.width = thWNew = thWNew + 'px';


      if (diffX > 0) {
         // $thEnd.css('width', '');
         if ($thEnd[0].offsetWidth > 25) return;
      }
      // else {
      //    $thEnd.css('width', Math.abs(thEndW - diffX) + 'px');
      // }

      d_opts.width = (tblW + diffX) + 'px';
   });

   return new Promise((res, rej) => {
      $(window).one('mouseup', (e) => {
         $(document).off('mousemove');
         col.resizing = null;
         res(thWNew);
      });
   });

}

function fn_profilePicURL(tmId) {
   return api_baseURL + 'profilePicture?tmid=' + tmId + '&sm=true';
}


function fn_wss_uc(set) {
   let uc = 'unsaved-changes';

   if (set) window.sessionStorage.setItem(uc, true);
   else window.sessionStorage.removeItem(uc);
}




async function fn_getUserOpts(prop, key) {
   let cats = [];
   switch (key) {
      case 'tbl': cats = ['tableColumnsVisible', 'tableColumnWidths', 'tableColumnSorts',
						'tableReadOnlyColumns','tableRequiredColumns']; 
		break;
      case 'brd': cats = ['boardFieldsVisible']; break;
      case 'tsk': cats = ['taskFormFieldsHidden']; break;
   }
   let usrOpts = userSettings.userOptions;
   let propCnt = 0;
   cats.forEach(cat => {
      let usrOpt = usrOpts[cat];
      if (!usrOpt) {
         usrOpt = usrOpts[cat] = {}; //Storing to ref-Data.js
      }
      if (usrOpt[prop]) propCnt++;
   });
   return new Promise((resFn, rej) => {
      if (propCnt != cats.length) {
         // let cat = cats.length == 1 ? cats[0] : null;
         fn_getAppUserSettings(null, prop).then(resp => {
			 console.log('In util fn_getAppUserSettings:resp');
			 console.log('prop:'+prop);
			 console.log(resp);
            let usrOptsResp = resp.userOptions || {};
			let allUsrOptsResp=resp.allUsersOptions||{};
			let readOnlyCol;
			let requiredCol
            cats.forEach(cat => {
			if(cat=='tableReadOnlyColumns'){
				readOnlyCol=allUsrOptsResp[cat]||[];
				usrOpts[cat][prop] = [...readOnlyCol];
				if(prop.substr(0,13) !==prop) usrOpts[cat][prop.substr(0,13)] = [...readOnlyCol];
				} else if(cat=='tableRequiredColumns'){
					requiredCol=allUsrOptsResp['tableRequiredColumns']||[];
					usrOpts[cat][prop]=[...requiredCol];
					if(prop.substr(0,13) !==prop) usrOpts[cat][prop.substr(0,13)] = [...readOnlyCol];
				  }
					else usrOpts[cat][prop] = usrOptsResp[cat] || {}; //Keep as empty object on purpose for current session.
            });
            resFn();
         });
      }
      else {
         resFn();
      }
   });
}

let save_timeouts = {};
function fn_saveUserOpts(prop, category, value) {
   let usrOpts = userSettings.userOptions;

   let usrOpt = usrOpts[category || prop];
   if (category) {
      if (!usrOpt) usrOpt = usrOpts[category] = {};
      usrOpt[prop] = value;
   }
   else {
      usrOpts[prop] = value;
   }



   //Send to server with a 5 sec delay
   let settingData = {category, prop, value};
   let toKey = prop + (category || 'MISC');
   let to = save_timeouts[toKey];
   if (to) clearTimeout(to);
   save_timeouts[toKey] = setTimeout(() => {
      fn_saveAppUserSetting(settingData);
      delete save_timeouts[toKey];
   }, 5000);
}
function fn_photoURL(photoId) {
   return api_baseURL + 'photo?photoId=' + photoId;
}
function fn_timeFmt(time){
	if(/(AM|PM)$/.test(time.toUpperCase())) return time;
	var today = new Date().toISOString().slice(0,10);
	var todayWithTime = new Date(today+'T'+time);
	return todayWithTime.toLocaleTimeString(navigator.language||'en-US',{ hour: "2-digit", minute: "2-digit" });
}

function fn_lkpRefNameId(_refData, col, nameVal) {
   if (!(_refData || []).length) return null;

   let idKey = _refData[0].id ? 'id' : (col._refId || col.field || col.key || '');
   let nameKey = _refData[0].name ? 'name' : (col._refName || (idKey.slice(0, -2) + 'Name'));
   let lkp = _refData.filter(x => x[nameKey] == nameVal)[0];

   if (lkp) {
      return lkp[idKey];
   }
   else {
      return null;
   }
}

function fn_getMoal_upload(vc) {
   let ce = vc.$createElement;
   let title = ce('div',
      [
         ce('fa-icon',
            {
               attrs: {icon: 'file-excel', color:'green', },
               class: {"mr-2": true, }
            }
         ),
         ce('span', 'upload')
      ]
   );

   let msgVNode = ce('b-form-group',
      {
         attrs: {label: 'Select from the options below', 'label-for': 'bm-create-new-opt', },
      },
      [
         ce('b-form-select',
            {
               attrs: {
                  id: 'bm-create-new-opt',
                  options: vc.c_crtNwOpts,
                  size: "sm",
                  plain: true,
               },
               on: {
                  change: (e) => {vc.d_crtNwKey = e;}
               },
               props: {
                  value: vc.d_crtNwKey
               },
            }
         )
      ]
   );

   let opt = fn_getCommonMsgBoxOpts();
   opt.title = title;
   return {msgVNode, opt};

}  
function fn_userAvailablePages(){
	let availablePages=userSettings.userOptions.enabledPages.available;
	  if(!availablePages){
	   availablePages={Home:[ 	"Admin",
								"Address Book",
								"Accounts",
								"Account Activities",
								"Calendar",
								"Calendar Activities",
								"Meetings",
								"Competitors",
								"Contacts",								
								"Create New",
								"Dashboard",
								"Opportunities",
								"Opportunity Activities",
								"Options",
								"Projects",
								"Project Activities",
								"Sales Forecasting",
								"Revenue Forecasting",
								"Settings",
								"Staffing Management",
								"Team Members",
								"Team Chat",
								"My Pages"
								],
					Calendar:["Add",
								"Activities"
								],
					"Sales Forecasting":["Add Monthly Goals",
										"Add Quarterly Goals",
										"Add Company's Monthly Goals",
										"Add Company's Quarterly Goals",
										],
					Opportunities:["Activities",
									"Business Insight",
									"Bid Form",
									"Clone",
									"Create New",
									"Debrief",
									"Decision",
									"Documents",
									"Edit",
									"Team Build"
									],
					Projects:["Activities",
									"Clone",
									"Create New",
									"Documents",
									"Edit",
									"Busines Insight",
									"Debrief"
									],
					Accounts:["Activities",
								"Create New",
								"Clone",
								"Documents",
								"Edit",
								"Related",
									],
					Competitors:["Create New",
								"Edit",
								 "Related"
									],
					Contacts:[	"Address Book",
								"Create New",
								"Edit",
								"Related",
									],
					"Team Members":[
									"Create New",
									"Edit",
									"Related",
									"Workload Management",
									]
		};
	
		
   }
    return availablePages;
}
function fn_userEnabledPages() {
   let enabledPages = userSettings.userOptions.enabledPages?.enabled;
 
   if(!enabledPages){
	   enabledPages={Home:[ 	"Admin",
								"Address Book",
								"Accounts",
								"Account Activities",
								"Calendar",
								"Calendar Activities",
								"Meetings",
								"Competitors",
								"Contacts",								
								"Create New",
								"Dashboard",
								"Opportunities",
								"Opportunity Activities",
								"Options",
								"Projects",
								"Project Activities",
								"Sales Forecasting",
								"Revenue Forecasting",
								"Settings",
								"Staffing Management",
								"Team Members",
								"Team Chat",
								"My Pages"
								],
					Calendar:["Add",
								"Activities"
								],
					"Sales Forecasting":["Add Monthly Goals",
										"Add Quarterly Goals",
										"Add Company's Monthly Goals",
										"Add Company's Quarterly Goals",
										],
					Opportunities:["Activities",
									"Business Insight",
									"Bid Form",
									"Clone",
									"Create New",
									"Debrief",
									"Decision",
									"Documents",
									"Edit",
									"Team Build"
									],
					Projects:["Activities",
									"Clone",
									"Create New",
									"Documents",
									"Edit",
									"Busines Insight",
									"Debrief"
									],
					Accounts:["Activities",
								"Create New",
								"Clone",
								"Documents",
								"Edit",
								"Related",
									],
					Competitors:["Create New",
								"Edit",
								 "Related"
									],
					Contacts:[	"Address Book",
								"Create New",
								"Edit",
								"Related",
									],
					"Team Members":[
									"Create New",
									"Edit",
									"Related",
									"Workload Management",
									]
		};
		
		
   }
   return enabledPages;
}
function fn_checkPageEnabled(page,e=null){
		console.log(`page: ${page} e: ${e}`);
		var enabledPages=fn_userEnabledPages();
		console.log('enabledPages[page]');
		console.log(enabledPages);
		console.log(enabledPages[page]);
		if(e) return enabledPages[page].includes(e);
		else return enabledPages['Home'].includes(page);
}
function fn_checkValidRoute(route){
		var enabledPages=fn_userEnabledPages();
		var map=new Map([['oppr','Opportunities'],
						['proj','Projects'],
						['acct','Accounts'],
						['extr','Contacts'],
						['cmpt','Competitors'],
						['team','Team Members'],
						['sett','Settings'],
						['cale','Calendar'],
						['dash','Dashboard'],
						['sale','Sales Forecasting'],
						['reve','Revenue Forecasting'],
						['meet','Meetings'],
						['addr','Address Book'],
						['cal-','Calendar Activities'],
						['staf','Staffing Management']
								]);
		return enabledPages['Home'].includes(map.get(route))||route=='sett'||
		route=='admi'||route=='emai'||route=='staf'||route=='reve';
}
function kbdpAlertInfo(vc,title,msg){
         vc.$bvModal.msgBoxOk(msg, {
          size: 'md',
          title :title,
          headerClass: 'p-2',
          headerBgVariant:'primary',
          buttonSize: 'sm',
          okVariant: 'primary',
          footerClass: 'p-2 border-top-0',
          centered: true
        })
 }
 
function enableResizableTable(tableId){
	console.log('In m_makeColumnsResizable');
	console.log(tableId);
	let headers = document.getElementById(tableId).querySelectorAll("th");
	console.log(headers)
	
	let isResizing = false;
	let startX;
	




    headers.forEach((header, index) => {
	
			function handleResize(event) {
				if (isResizing) {
					const newWidth = header.offsetWidth + (event.pageX - startX);
					header.style.width = `${newWidth}px`;
					startX = event.pageX;
				}
			}


			function stopResize() {
				isResizing = false;
				document.removeEventListener("mousemove", handleResize);
				document.removeEventListener("mouseup", stopResize);
			}
			
        header.style.position = "relative";

        if (index < headers.length - 1 && !header.classList.contains("no-resize")) {
            const nextNonResizable = [...headers].slice(index + 1).some(th => th.classList.contains("no-resize"));
            if (!nextNonResizable) {
                const resizer = document.createElement("div");
                resizer.className = "resizer";
                resizer.style.position = "absolute";
                resizer.style.top = "0";
                resizer.style.right = "-3px";
                resizer.style.bottom = "0";
                resizer.style.width = "6px";
                resizer.style.zIndex = "999";
                resizer.style.background = "transparent";
                resizer.style.cursor = "col-resize";

                header.appendChild(resizer);
				

            resizer.addEventListener("mousedown", (event) => {
                    isResizing = true;
                    startX = event.pageX;
                    document.addEventListener("mousemove", handleResize);
                    document.addEventListener("mouseup", stopResize);
            });

               
            }
        }
    });

    document.addEventListener("mouseup", function() {
        headers.forEach(header => header.classList.remove("resizing"));
    });
	
	}
	
	


function enableResizableColumn(resizerClass){
document.querySelectorAll("."+resizerClass).forEach(resizer => {
    let isResizing = false;
    let startX;
    let startWidth;

    resizer.addEventListener("mousedown", (event) => {
        isResizing = true;
        startX = event.clientX;
        startWidth = resizer.parentElement.offsetWidth;
        document.addEventListener("mousemove", handleResize);
        document.addEventListener("mouseup", stopResize);
    });

    function handleResize(event) {
        if (isResizing) {
			
            const newWidth = startWidth + (event.clientX - startX);
			console.log(`StartX ${startX} newWidth ${newWidth}`);
            resizer.parentElement.style.flex = `0 0 ${newWidth}px`;
        }
    }

    function stopResize() {
        isResizing = false;
        document.removeEventListener("mousemove", handleResize);
        document.removeEventListener("mouseup", stopResize);
    }
	
	
	});
}
function getTimeZone() {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;

    // Determine if DST is active right now
    const now = new Date();
    const jan = new Date(now.getFullYear(), 0, 1);
    const jul = new Date(now.getFullYear(), 6, 1);

    // If timezone offset in summer differs from winter → DST is used
    const dstActive = now.getTimezoneOffset() < Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());

    // Map IANA → base zone (EST, CST, MST, PST)
    const zoneMap = {
        // Eastern Time Cities
        "America/New_York": "EST",      // NYC, Philadelphia, Raleigh, Atlanta, Miami, Orlando, Pittsburgh
        "America/Detroit": "EST",
        "America/Toronto": "EST",
        "America/Montreal": "EST",
        "America/Indiana/Indianapolis": "EST",
        "America/Kentucky/Louisville": "EST",
        "America/Kentucky/Monticello": "EST",
        "America/Indiana/Marengo": "EST",
        "America/Indiana/Vevay": "EST",
        "America/Indiana/Vincennes": "EST",
        "America/Indiana/Winamac": "EST",
        "America/Indiana/Petersburg": "EST",

        // Central Time Cities
        "America/Chicago": "CST",       // Chicago
        "America/Houston": "CST",       // Houston
        "America/Indiana/Tell_City": "CST",
        "America/Indiana/Knox": "CST",
        "America/Menominee": "CST",
        "America/Winnipeg": "CST",
        "America/Regina": "CST",

        // Mountain Time Cities
        "America/Denver": "MST",
        "America/Phoenix": "MST",       // Phoenix (no DST)
        "America/Edmonton": "MST",
        "America/Boise": "MST",

        // Pacific Time Cities
        "America/Los_Angeles": "PST",
        "America/Vancouver": "PST",
        "America/Tijuana": "PST",
        "America/Seattle": "PST"
    };

    let baseZone = zoneMap[tz] || tz;

    // Phoenix does NOT observe DST → always MST
    if (tz === "America/Phoenix") {
        return "MST";
    }

    // Apply DST suffix if applicable
    if (dstActive) {
        if (baseZone === "EST") return "EDT";
        if (baseZone === "CST") return "CDT";
        if (baseZone === "MST") return "MDT";
        if (baseZone === "PST") return "PDT";
    }

    return baseZone;
}

